import { createSlice } from '@reduxjs/toolkit';
import { notifyUserError } from 'utils/notifications';

import { ConsentMessage, getClientConsentMessage } from './clientConsentActions';

type ClientConsentSliceProps = {
  consentMessage: {
    loading: boolean;
    data: ConsentMessage | null;
  };
};

const initialState: ClientConsentSliceProps = {
  consentMessage: {
    loading: false,
    data: null
  }
};

export const clientConsentSlice = createSlice({
  name: 'clientConsentSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClientConsentMessage.pending, (state) => {
        state.consentMessage.loading = true;
      })
      .addCase(getClientConsentMessage.fulfilled, (state, { payload }) => {
        state.consentMessage = {
          loading: false,
          data: payload
        };
      })
      .addCase(getClientConsentMessage.rejected, (state, { payload }: any) => {
        state.consentMessage.loading = false;
        notifyUserError(payload);
      });
  }
});

export default clientConsentSlice.reducer;
